import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-root',
    imports: [RouterModule, ConfirmDialogModule, ToastModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <p-toast position="top-right" [baseZIndex]="1200" styleClass="toast-stack"> </p-toast>

        <p-confirmdialog  [style]="{ width: '28rem' }" styleClass="overflow-hidden rounded-2xl shadow-2xl border border-surface-200 dark:border-surface-700" [acceptVisible]="true" [rejectVisible]="true" [closeOnEscape]="true" rejectButtonStyleClass="p-button-text">
            <ng-template pTemplate="header" let-message>
                <div class="flex items-center gap-3">
                    <div class="h-10 w-10 rounded-full flex items-center justify-center" [class]="getConfirmIconWrapClass(message)">
                        <i [class]="getConfirmIconClass(message)"></i>
                    </div>
                    <div>
                        <p class="m-0 text-sm uppercase tracking-wide text-surface-500 dark:text-surface-400">Atencao</p>
                        <h3 class="m-0 text-base font-semibold text-surface-900 dark:text-surface-0">{{ getConfirmHeader(message) }}</h3>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="message" let-message>
                <p class="m-0 text-sm text-surface-600 dark:text-surface-300" [innerHTML]="message?.message || 'Deseja continuar?'"></p>
            </ng-template>
        </p-confirmdialog>

        <router-outlet></router-outlet>
    `
})
export class AppComponent implements OnInit {
    protected getToastCardClass(severity?: string): string {
        switch (severity) {
            case 'success':
                return 'border-green-200 dark:border-green-800 bg-green-50/80 dark:bg-green-950/30';
            case 'warn':
                return 'border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-950/30';
            case 'error':
                return 'border-red-200 dark:border-red-800 bg-red-50/80 dark:bg-red-950/30';
            case 'info':
            default:
                return 'border-blue-200 dark:border-blue-800 bg-blue-50/80 dark:bg-blue-950/30';
        }
    }

    protected getToastIconWrapClass(severity?: string): string {
        switch (severity) {
            case 'success':
                return 'bg-green-100 text-green-600 dark:bg-green-900/40 dark:text-green-300';
            case 'warn':
                return 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200';
            case 'error':
                return 'bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-300';
            case 'info':
            default:
                return 'bg-blue-100 text-blue-600 dark:bg-blue-900/40 dark:text-blue-300';
        }
    }

    protected getToastIconClass(severity?: string): string {
        switch (severity) {
            case 'success':
                return 'pi pi-check-circle';
            case 'warn':
                return 'pi pi-exclamation-triangle';
            case 'error':
                return 'pi pi-times-circle';
            case 'info':
            default:
                return 'pi pi-info-circle';
        }
    }

    protected getConfirmHeader(message?: { header?: string }): string {
        return message?.header || 'Confirmar acao';
    }

    protected getConfirmIconWrapClass(message?: { severity?: string }): string {
        switch (message?.severity) {
            case 'info':
                return 'bg-blue-50 text-blue-600 dark:bg-blue-900/40 dark:text-blue-300';
            case 'success':
                return 'bg-green-50 text-green-600 dark:bg-green-900/40 dark:text-green-300';
            case 'warn':
                return 'bg-amber-50 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200';
            case 'danger':
            default:
                return 'bg-red-50 text-red-600 dark:bg-red-900/40 dark:text-red-300';
        }
    }

    protected getConfirmIconClass(message?: { icon?: string; severity?: string }): string {
        if (message?.icon) {
            return message.icon;
        }

        switch (message?.severity) {
            case 'info':
                return 'pi pi-info-circle';
            case 'success':
                return 'pi pi-check-circle';
            case 'warn':
                return 'pi pi-exclamation-triangle';
            case 'danger':
            default:
                return 'pi pi-exclamation-triangle';
        }
    }

    ngOnInit() {
        // Esconde a splashscreen após o Angular carregar
        const loader = document.getElementById('splash-screen');
        if (loader) {
            loader.style.display = 'none';
        }
    }
}
